export const classes = [
    { Ng: 'compact-wrapper' }
  ];